import { generateRandomNumber, } from './number';

export const generateWallboardKey = (): number => {
  return generateRandomNumber(100000, 999999);
};
